export default {
  michelle: {
    job: 'MM Operations Manager, Elementary Education',
    name: 'Melody Schuster',
    photo: 'https://github.com/MindMakersProject/website-BE/blob/master/photos/MelodySchuster200x200.jpg?raw=true',
    quote: "You think about engineering, it’s difficult, it seems almost impossible, so to show that you can be an engineer when you thought you couldn't is an amazing thing and I love the idea of inspiring people to do things that they could never imagine doing"
  },
  isis: {
    job: 'Advisor, Mind Makers & Software Engineer @ Hustle',
    name: 'Isis Anchalee',
    photo: 'https://github.com/MindMakersProject/website-BE/blob/master/photos/IsisAnchalee200x200.jpg?raw=true',
    quote: 'The goal of Mind Makers is to blow any preconcieved notion of who can do anything out of the water.'
  },
  bobak: {
    job: 'MM Volunteer Coordinator',
    name: 'Sina Henrie',
    photo: 'https://github.com/MindMakersProject/website-BE/blob/master/photos/SinaJandscheidt200x200.jpg?raw=true',
    quote: "This is a beautiful project to expose people to something they didn't think they can be a part of. It can be any other industry, it doesn't have to be STEM, what this project is about is to show that it doesn't matter where you are in your life you can do whatever you want to do, sometimes you just have to get a bit more help."
  }
};



// WEBPACK FOOTER //
// ./src/configs/inspirational-quote-config.js